import { StyledButton } from './styles'
import type { ButtonProps } from './types'

export type { ButtonVariant, ButtonSize, ButtonProps } from './types'

export const Button = ({
  variant = 'primary',
  size = 'md',
  type = 'button',
  fullWidth,
  children,
  ...rest
 }: ButtonProps) => (
  <StyledButton $variant={variant} $size={size} $fullWidth={fullWidth} type={type} {...rest}>
    {children}
  </StyledButton>
)
